import { ErrorMessage, FieldProps } from "formik";
import React from "react";

import { Props } from "./NumberInputInterface";

import "./NumberInput.scss";

const NumberInput: React.FC<FieldProps & Props> = ({ field, form: { errors, touched }, onBlur, label, disabled }: any) => {
    const { name } = field;

    const isTouched = touched[name];
    const errorMessage = isTouched && errors[name];

    const handleBlur = (e) => {
        field.onBlur(e);
        if (onBlur) {
            onBlur(e);
        }
    };

    return (
        <div className={`c-number-input ${errorMessage ? "c-number-input--error":""}`}>
            <label className="c-number-input__label" htmlFor={name}>
                {label}
            </label>

            <input className="c-number-input__input" type="number" {...field} value={field.value || ""} onBlur={handleBlur} disabled={disabled} />

            <div className="c-number-input__error">
                <ErrorMessage name={name} />
            </div>
        </div>
    );
};

export default NumberInput;
